<template>
  <table class="table-main">
    <tr v-if="!hideLogoAndCarousel">

      <td class="simulation">
        <simulation
          v-if="enterpriseID"
          :ID="enterpriseID"
          :colapse="true"
        />
      </td>
      <td style="padding-left: 10px;">
        <h1 style="margin-left: 20px;margin-top: 15px;margin-bottom: 50px;"><v-icon style="margin-bottom:5px;font-size:30px; color: rgba(0, 0, 0, 0.87);">mdi-cellphone-settings</v-icon>{{ enterpriseName }}</h1>
        <v-card
          class="pa-4"
          flat
        >
          <v-toolbar :color="enterpriseColor" dark style="margin-top: -50px;margin-bottom:10px;opacity:0.7; border-radius: 5px;">
            <v-icon style="margin-right: 10px;">mdi-image-area-close</v-icon>
            <v-toolbar-title>{{ $t('settings.logoAndCarousel.title') }}</v-toolbar-title>
            <v-spacer />
          </v-toolbar>
          <form-logoAndCarousel
          />
        </v-card>
      </td>
      <td class="td-info" rowspan="2">
        <info-settings />
      </td>
    </tr>
    <tr v-if="!hideColors">
      <td class="simulation">
        <simulation
          v-if="enterpriseID"
          :ID="enterpriseID"
        />
      </td>
      <td style="padding-left: 5px;padding-top: 55px;">
        <v-card
          class="pa-4"
          flat
        >
          <v-toolbar :color="enterpriseColor" dark style="margin-top: -50px;margin-bottom:10px;opacity:0.7;border-radius: 5px;">
            <v-icon style="margin-right: 10px;">mdi-palette</v-icon>
            <v-toolbar-title>{{ $t('settings.colors.title') }}</v-toolbar-title>
            <v-spacer />
          </v-toolbar>
          <form-colors
          />
        </v-card>
      </td>
    </tr>
    <tr v-if="!hideWelcomeModal">
      <td class="simulation">
        <!-- <simulation
          v-if="enterpriseID"
          :ID="enterpriseID"
        /> -->
      </td>
      <td style="padding-left: 5px;padding-top: 55px;">
        <v-card
          class="pa-4"
          flat
        >
          <!-- <v-toolbar :color="enterpriseColor" dark style="margin-top: -50px;margin-bottom:10px;opacity:0.7;border-radius: 5px;">
            <v-icon style="margin-right: 10px;">mdi-sticker-alert</v-icon>
            <v-toolbar-title>{{ $t('settings.welcomeModal.title') }}</v-toolbar-title>
            <v-spacer />
          </v-toolbar> -->
          <form-welcome-modal />
        </v-card>
      </td>
    </tr>
    <tr>
      <td class="simulation">
        <!-- <simulation
          v-if="enterpriseID"
          :ID="enterpriseID"
        /> -->
      </td>
      <td style="padding-left: 5px;padding-top: 55px;">
        <v-card
          class="pa-4"
          flat
        >
          <v-toolbar :color="enterpriseColor" dark style="margin-top: -50px;margin-bottom:10px;opacity:0.7;border-radius: 5px;">
            <v-icon style="margin-right: 10px;">mdi-file-sign</v-icon>
            <v-toolbar-title>{{ $t('settings.formTerms.title') }}</v-toolbar-title>
            <v-spacer />
          </v-toolbar>
          <form-terms :workspaceID="enterpriseID" v-if="enterpriseID" />
        </v-card>
      </td>
    </tr>
  </table>
</template>

<script>
  import api from '@/services/api'
  import utils from '@/services/utils'
  import Simulation from '@/views/public/mobile/Index'
  import FormLogoAndCarousel from './FormLogoAndCarousel'
  import InfoSettings from './InfoSettings'
  import FormColors from './FormColors'
  import FormWelcomeModal from './formWelcomeModal/Index'
  import FormTerms from './formTerms/Index'
  export default {
    components: {
      Simulation,
      FormLogoAndCarousel,
      FormColors,
      InfoSettings,
      FormWelcomeModal,
      FormTerms,
    },
    data: () => ({
      hideColors: false,
      hideLogoAndCarousel: false,
      hideWelcomeModal: false
    }),
    computed: {
      enterpriseID () {
        return this.$store.state.app.enterpriseID
      },
      enterpriseName () {
        return this.$store.state.app.enterpriseName
      },
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      }
    },
    mounted () {
      api.getItem('users', true, utils.getUserID()).then(response => {
        this.hideColors = response.HideColors
        this.hideLogoAndCarousel = response.HideLogoAndCarousel
        this.hideWelcomeModal = response.HideWelcomeModal
      })
    }
  }
</script>
<style lang="scss">
  h1 {
    font-weight: normal;
  }
  .table-main {
    width: 100%;
  }
  .table-main td {
    vertical-align: top;
  }
  .table-main.body {
    width: auto;
  }
  .simulation {
    width: 400px;
    padding: 20px 5px 0px 20px;
  }
  .td-info {
    width: 300px;
    padding: 80px 15px 0px 15px;
  }
</style>
